/**
 * Returns the formatted date in MM/YY format.
 *
 * @param {String} value
 * @returns {String}
 */
export default function formatExpiry(value) {
  return (
    value
      // user started typing '1/', prepend a zero to become '01/'
      .replace(/^1\/$/, '01/')
      // user started typing '13' (or higher, impossible months), prepend a zero to become '01/3'
      .replace(/^1([3-9])/, '01/$1')
      // user started typing '2' (or higher, impossible months), prepend a zero
      .replace(/^([2-9])/, '0$1/')
      // format as MM/YY
      .replace(/^([0-9]{2})([0-9]+)/, '$1/$2')
      // ensure date does not exceed 5 characters
      .replace(/^(.{5}).*$/, '$1')
  )
}
